import {AppContext} from "../../../lib/AppContext";
import React, {forwardRef, useContext, useEffect, useState} from "react";
import {
  addDate,
  displayDay,
  displayDuration,
  eventSortTimeFn,
  formatDate,
  formatDateMask,
  formatTime
} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {
  getAgeRangeTypes,
  getClientInventoryEvents,
  getEventLocations,
  getInventoryEvents,
  getInventoryEventTypes
} from "../../common/api/InventoryApi";
import {Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import * as pagination from "../../common/pagination";
import BootyPagination from "../../common/bootyPagination";
import DataTable from "react-data-table-component";
import Icon from "@mui/material/Icon";
import Loading from "../../common/Loading";
import Avatar from "@mui/material/Avatar";
import {getCookie, setCookie} from "../../common/appCookie";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import ManageMassInventoryEventModal from "../../inventory/ManageMassInventoryEventModal";
import FileSelector from "../../calendarUI/FilterSelector";
import MDInput from "../../../components/MDInput";
import {CONSTANTS} from "../../common/constants";
import Switch from "@mui/material/Switch";
import ExtendedBootyPagination from "../../common/extendedBootyPagination";

export default function EventsMiniDataTable(props) {
  const navigate = useNavigate();

  const registerFn = props.register || null;
  const [context, setContext] = useContext(AppContext);
  const [client, setClient] = useState(null);

  const [specialEvents, setSpecialEvents] = useState(props?.specialEvents);
  const [excludeSpecial, setExcludeSpecial] = useState(props?.excludeSpecial);
  const [embedded, setEmbedded] = useState(props?.embedded || false);

  const registerMembershipEvent = (event, memberAccount) => {
    let e = {...event};
    e.memberAccount = {...memberAccount};
    registerFn(e);
  }

  useEffect(() => {
    if (props.client) {
      setClient(props.client);
    }
    setEventDate(new Date());
  }, [props?.client]);

  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [events, setEvents] = useState([]);
  const [inventoryRender, setInventoryRender] = useState(1);

  const [searchParams, setSearchParams] = useSearchParams();
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);

  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [render, setRender] = useState(0);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);
  const rowOption = 20;

  const [pageSize, setPageSize] = useState(searchParams.get('pageSize') || getCookie('EVENTS_ROW') || rowOption);

  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const [rangeReport, setRangeReport] = useState(false);
  const [bookedFull, setBookedFull] = useState(false);

  const toggleReportRange = () => {
    setRangeReport(!rangeReport)
  }

  const toggleBookedFull = () => {
    setBookedFull(!bookedFull)
  }

  const [eventDate, setEventDate] = useState(null);
  const [eventEndDate, setEventEndDate] = useState(new Date());

  const handleSort = (column, sortDirection) => {
    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('EVENTS_SORT', column.id);
    setCookie('EVENTS_SORT_DIR', sortDirection);
    setRender(render + 1);

  };

  const linkToClient = (member) => {
    return <Link className="link"
                 href={'/client/' + member?.guid} to={'/client/' + member?.guid}>
      {member?.lastName + (member?.firstName ? ', ' + member?.firstName : '')}</Link>;
  }

  const displayReservations = (event) => {
    let attendees = [];

    event?.reservations?.map((a, idx) => {
      attendees.push(<span key={idx}>
        {linkToClient(a.attendee)}
      </span>)
    });

    return (attendees.map((att, idx) => {
      return (<span style={{marginRight: '2px'}} key={idx}>{att}</span>)
    }));
  }

  const registerOptions = (row) => {
    if (!row?.eventType?.requireAttendees && row.memberAccountTypes?.length > 0) {
      return <div>
        {row.memberAccountTypes.map((_row, index) => {
          return (<MDButton onClick={() => registerMembershipEvent(row, _row)}
                            size={'small'}
                            key={index}
                            variant="gradient"
                            color="info">
            Register ({_row.name})
          </MDButton>)
        })
        }
      </div>

    } else {
      return <div>
        <MDButton onClick={() => registerFn(row)} variant="gradient"
                  size={'small'}
                  color="secondary">
          Register
        </MDButton>
      </div>
    }
  }

  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };

  const _columns = [
    {
      name: <span className='th'></span>,
      id: -1,
      width: '52px',
      selector: row => row.name,
      cell: row => {
        return <Avatar alt={row.name} sx={{width: 32, height: 32}}>
          {row.imageUrl &&
            <img src={row.imageThumbUrl ? row.imageThumbUrl : row.imageUrl} style={{width: '200%', height: 'auto'}}
                 alt={row.name}/>}
          {!row.imageUrl && row.name.substring(0, 2)}
        </Avatar>;
      },
      sortable: false,
    },
    {
      name: <span className='th'>Name</span>,
      id: 'name',
      selector: row => row.name,
      cell: row => {
        let link = '/event/view/' + row.guid;
        return <Link to={link} className="link"> {row.name} </Link>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Status</span>,
      id: 'status',
      selector: row => row.status?.name,
      cell: row => {
        return <>{row?.status?.name}</>
      },
      sortable: true,
    },
    {
      name: <span className='th'>Location</span>,
      id: 'location',
      selector: row => row.eventLocation?.name || '',
      sortable: true,
      sortFunction: (a, b) =>
        (a.eventLocation?.name || '').localeCompare(
          b.eventLocation?.name || '',
          undefined,
          {sensitivity: 'base'}
        ),
      cell: row =>
        row.eventLocation?.name ? (
          <>
            <Icon color="success">place</Icon> {row.eventLocation.name}
          </>
        ) : null,
    },
    {
      name: <span className='th'>{specialEvents ? 'Booked' : 'Session'}</span>,
      id: 'sessionEvent',
      selector: row => specialEvents ? row.bookedFull : row.sessionEvent,
      cell: row => {
        if (specialEvents) {
          return <>{row.bookedFull ? <Icon>check</Icon> : ''} </>
        } else {
          return <>{row.sessionEvent ? <Icon>check</Icon> : ''} </>
        }
      },
      sortable: true,
    },

    {
      name: <span className='th'>{specialEvents ? 'Booked By' : ''}</span>,
      id: 'bookedBy',
      selector: row => row.bookedFull,
      omit: !specialEvents,
      cell: row => {
        if (specialEvents) {
          return <>{displayReservations(row)}</>
        } else {
          return <>{row.sessionEvent ? <Icon>check</Icon> : ''} </>
        }
      },
      sortable: true,
    },

    {
      name: <span className='th'>Recurring</span>,
      id: 'recurringEvent',
      selector: row => row.recurringEvent,
      cell: row => {
        return <>{row.recurringEvent ? <Icon>check</Icon> : ''} </>
      },
      sortable: true,
    },
    {
      name: <span className='th'>Registered</span>,
      id: 'totalReservations',
      selector: row => row.totalReservations,
      cell: row => {
        return <>{row?.totalReservations || 0} </>
      },
      sortable: true,
    },
    {
      name: <span className='th'>Date</span>,
      id: 'eventDate',
      selector: row => row.eventDate,
      cell: row => {
        return <>{formatDate(row.eventDate)} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Start Time</span>,
      id: 'eventStartTime',
      selector: row => row.eventDate,
      cell: row => {
        return <>{displayDay(row.eventDate, 'hh:mm a')} </>;
      },
      sortFunction: eventSortTimeFn,
      sortable: true,
    },
    {
      name: <span className='th'>End Time</span>,
      id: 'eventEndDate',
      selector: row => row.eventEndDate,
      cell: row => {
        return <>{displayDay(row.eventEndDate, 'hh:mm a')} </>;
      },
      sortFunction: eventSortTimeFn,
      sortable: true,
    },
    {
      name: <span className='th'>Duration</span>,
      id: 4,
      selector: row => row.duration,
      cell: row => {
        return <>{displayDuration(row)}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>View</span>,
      id: 5,
      right: true,
      selector: row => row.guid,
      cell: row => {
        if (registerFn) {
          return registerOptions(row);
        } else {
          let link = '/event/view/' + row.guid;
          return <div><MDButton href={link} size={'small'} color="primary">View</MDButton></div>
        }
      },
      sortable: false,
    }
  ];

  const [columns, setColumns] = useState(_columns);

  useEffect(() => {

    if (!eventDate) {
      return;
    }

    let startDate = new Date(eventDate);
    startDate.setHours(0, 0, 0, 0);

    let req = {
      start: startDate,
      end: eventEndDate,
      specialEvents: specialEvents,
      excludeSpecial: excludeSpecial
    }
    getInventoryEventsFn(req, props?.client);
  }, [eventDate]);

  const getInventoryEventsFn = async (req, client) => {
    setEventsLoading(true);
    setSelectedRows([]);
    let result = client ? await getClientInventoryEvents(req, client, inventoryRender) : await getInventoryEvents(req, inventoryRender);
    setEvents(result.events);
    setEventsLoading(false);
    setLoading(false);
  }
  const [reportPeriod, setReportPeriod] = useState();

  const updateEventDates = (date) => {
    setEventDate(date);
    if (props?.dateCallback) {
      props.dateCallback(date);
    }
    if (!rangeReport) {
      setEventEndDate(addDate(date, 1));
    }
  }

  const getReport = () => {
    let startDate = new Date(eventDate);
    startDate.setHours(0, 0, 0, 0);
    let req = {
      start: startDate,
      end: startDate,
      specialEvents: specialEvents,
      excludeSpecial: excludeSpecial
    }
    if (rangeReport) {
      let endDate = new Date(eventEndDate);
      endDate.setHours(23, 59, 59, 999);

      req = {
        start: startDate,
        end: endDate,
        specialEvents: specialEvents,
        excludeSpecial: excludeSpecial
      }
    }

    getInventoryEventsFn(req, props?.client);
  }

  const updateEventEndDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventEndDate(_d);
    setReportPeriod(_period);
  }

  useEffect(() => {
    setCookie('eventDate', new Date(eventDate).getTime(), 1);
  }, [eventDate]);

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <div className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <Icon sx={{
        marginTop: '2px',
      }}>event</Icon>{formatDate(eventDate)}
    </div>
  ));

  const handleRowClick = (row) => {
    if (props?.callback) {
      props.callback(row);
      return;
    }
    events.map((_row) => {
      _row.selected = false;
    });
    row.selected = true;
    setEvents(events);
  }

  const conditionalRowStyles = [
    {
      when: row => row.selected,
      style: {
        backgroundColor: "#d7d5d5",
        userSelect: "none"
      }
    }
  ];

  const [massEdit, setMassEdit] = useState(false);

  const startMassEventEdit = () => {
    setMassEdit(true);
  }

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);

  const handleRowSelected = React.useCallback(state => {
    let selected = [];
    for (let j in state.selectedRows) {
      selected.push(state.selectedRows[j].guid)
    }
    setSelectedRows(selected);
  }, []);

  const [searchCriteria, setSearchCriteria] = useState();

  const handleSearchChange = (e) => {
    setSearchCriteria(e.target.value);
  }

  const [times, setTimes] = useState([]);
  const [timesFilter, setTimesFilter] = useState([]);

  const toMinutes = (time) => {
    const [clock, period] = time.split(' ');
    let [hours, minutes] = clock.split(':').map(Number);
    if (period === 'AM' && hours === 12) hours = 0;
    if (period === 'PM' && hours !== 12) hours += 12;
    return hours * 60 + minutes;
  };


  useEffect(() => {
    let _times = [];
    let _timeFilters = [];
    for (let j in events) {
      if (events[j].eventDate) {
        let val = formatTime(events[j].eventDate);
        let sortOrder = toMinutes(val);
        let key = val.replaceAll(/\s/g, '').toUpperCase();
        if (_times.indexOf(key) === -1) {
          _times.push(key);
          _timeFilters.push({
            sortOrder: sortOrder,
            id: key,
            name: val
          })
        }
      }
    }
    setTimes(_timeFilters);
  }, [events]);

  const [daysOfWeek, setDaysOfWeek] = useState([...CONSTANTS.DAYS_OF_WEEK]);
  const [daysOfWeekFilter, setDaysOfWeekFilter] = useState([]);

  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [eventTypeFilter, setEventTypeFilter] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);
  const [ageRangeTypeFilter, setAgeRangeTypeFilter] = useState([]);
  const statuses = [...CONSTANTS.STATUSES];

  const [eventLocations, setEventLocations] = useState([]);
  const [eventLocationTypeFilter, setEventLocationTypeFilter] = useState([]);
  const [statusTypeFilter, setStatusTypeFilter] = useState([]);

  const [eventsFiltered, setEventsFiltered] = useState([]);

  const filteredEvents = (events) => {
    let _events = [];
    for (let j in events) {
      if (showEvent(events[j])) {
        _events.push(events[j]);
      }
    }
    setEventsFiltered(_events);
  }

  useEffect(() => {
    setSelectedRows([]);
    setToggledClearRows(prev => !prev);
    filteredEvents(events);
  }, [events, statusTypeFilter, eventTypeFilter, ageRangeTypeFilter, eventLocationTypeFilter, searchCriteria, daysOfWeekFilter, timesFilter, bookedFull]);

  const loadEventLocations = () => {
    getEventLocations().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventLocations(result);
      }
    });
  }

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _r = [];
        for (let j in result) {
          if (excludeSpecial) {
            if (!result[j].specialEvent) {
              _r.push(result[j]);
            }
          } else {
            _r.push(result[j]);
          }
        }
        setInventoryEventTypes(_r);
      }
    });
  }

  const getAgeRangeTypesFn = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  useEffect(() => {
    loadInventoryEventTypes();
    getAgeRangeTypesFn();
    loadEventLocations();
  }, []);


  const filteredEvent = (item) => {
    if (!searchCriteria || searchCriteria.length === 0) {
      return true;
    }

    let nameCrit = item.name.toLowerCase();
    let match = nameCrit.match(searchCriteria.toLowerCase());
    if (match && match.length > 0) {
      return true;
    }

    return false;
  }

  const handleRowsPerPageChange = (selector, page) => {
    setStartPage(0);
    setPageSize(selector)
    setRender(render + 1);
    setSelectedRows([]);
    setToggledClearRows(!toggledClearRows);
    setCookie('EVENTS_ROW', selector);
  };

  const showEvent = (_event) => {
    let show = (eventTypeFilter.length === 0 || eventTypeFilter.indexOf(_event?.eventType?.id) > -1);
    show = show && (ageRangeTypeFilter.length === 0 || ageRangeTypeFilter.indexOf(_event?.ageRange?.id) > -1);
    show = show && (eventLocationTypeFilter.length === 0 || eventLocationTypeFilter.indexOf(_event?.eventLocation?.id) > -1);
    show = show && (statusTypeFilter.length === 0 || statusTypeFilter.indexOf(_event?.status?.id) > -1);
    show = show && (daysOfWeekFilter.length === 0 || daysOfWeekFilter.indexOf(_event?.displayDayOfWeek) > -1);
    if (bookedFull) {
      show = show && _event.bookedFull;
    }

    if (timesFilter.length > 0) {
      let eventDate = formatTime(_event.eventDate).replaceAll(/\s/g, '').toUpperCase();
      show = show && timesFilter.indexOf(eventDate) > -1;
    }

    show = show && filteredEvent(_event);
    return show;
  };

  return (
    <>
      <MDBox>
        <Grid container spacing={1} mb={2}>
          <Grid item xs={12}>
            <DesktopDatePicker
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '4px 0 0 4px'
                }
              }}
              closeOnSelect={false}
              views={['month', 'year', 'day']}
              slotProps={{
                actionBar: {
                  actions: ['today', 'accept'],
                },
              }}
              value={dayjs(eventDate)}
              onChange={(e) => {
                updateEventDates(e?.$d || null);
              }}
            />

            {rangeReport &&
              <DesktopDatePicker
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '4px 0 0 4px'
                  }
                }}
                closeOnSelect={false}
                views={['month', 'year', 'day']}
                minDate={dayjs(eventDate)}
                slotProps={{
                  actionBar: {
                    actions: ['today', 'accept'],
                  },
                }}
                value={dayjs(eventEndDate)}
                onChange={(e) => {
                  updateEventEndDates(e?.$d || null);
                }}
              />}
            <MDButton
              sx={{
                borderRadius: '0 4px 4px 0',
                height: '100%'
              }}
              color="info"
              onClick={() => {
                getReport();
              }}
            >Go</MDButton>
          </Grid>
        </Grid>


        <Grid container spacing={1}>

          <Grid item xs={12} sm={3}>
            <Grid container>
              <Grid item xs={12} sm={specialEvents? 6 : 12}>
                <label
                  htmlFor="rangeReport">
                  Date Range
                  <Switch
                    name={'rangeReport'}
                    id={'rangeReport'}
                    checked={rangeReport}
                    style={{marginRight: '5px'}}
                    onChange={toggleReportRange}
                  /> </label>
              </Grid>
              {specialEvents && <Grid item xs={12} sm={6}>
                <label
                  htmlFor="rangeReport">
                  Booked
                  <Switch
                    name={'bookedFull'}
                    id={'bookedFull'}
                    checked={bookedFull}
                    style={{marginRight: '5px'}}
                    onChange={toggleBookedFull}
                  /> </label>
              </Grid>}
            </Grid>
          </Grid>

          <Grid item xs={12} sm={3}>
            <FileSelector
              width={'98%'}
              types={times}
              typeFilter={timesFilter}
              filterLabel={'Event Times'}
              setFilter={(filters) => {
                setTimesFilter(filters)
              }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FileSelector
              width={'98%'}
              types={daysOfWeek}
              typeFilter={daysOfWeekFilter}
              filterLabel={'Days of Week'}
              setFilter={(filters) => {
                setDaysOfWeekFilter(filters)
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <MDInput type="text" style={{
              float: 'right',
              width: '98%',
              marginTop: '8px'
            }}
                     variant="outlined"
                     value={searchCriteria || ''}
                     onChange={handleSearchChange}
                     className="form-control" id="searchCriteria" aria-describedby="searchCriteria"
                     label="Search Events"/>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={6} sm={3}>
            <FileSelector
              width={'98%'}
              types={inventoryEventTypes}
              typeFilter={eventTypeFilter}
              filterLabel={'Event Types'}
              setFilter={(filters) => {
                setEventTypeFilter(filters)
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FileSelector
              width={'98%'}
              types={ageRangeTypes}
              typeFilter={ageRangeTypeFilter}
              filterLabel={'Ages'}
              setFilter={(filters) => {
                setAgeRangeTypeFilter(filters)
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FileSelector
              width={'98%'}
              types={eventLocations}
              typeFilter={eventLocationTypeFilter}
              filterLabel={'Event Location'}
              setFilter={(filters) => {
                setEventLocationTypeFilter(filters)
              }}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <FileSelector
              width={'98%'}
              types={statuses}
              typeFilter={statusTypeFilter}
              filterLabel={'Event Status'}
              setFilter={(filters) => {
                setStatusTypeFilter(filters)
              }}
            />
          </Grid>

        </Grid>

        <Divider/>

        <Grid container>
          <Grid item xs={12} sm={12}>
            {selectedRows?.length > 0 && <>
              <MDButton className={'pull-right'} size="small" color="info"
                        onClick={() => {
                          startMassEventEdit();
                        }}>
                Edit {selectedRows?.length} {selectedRows?.length === 1 ? 'Event' : 'Events'}
              </MDButton>
            </>}
          </Grid>
        </Grid>

        <Grid container spacing={2}>

          <Grid item xs={12}>
            {eventsLoading && <Loading/>}

            {!eventsLoading && <DataTable
              striped
              noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                             fontWeight={'light'}>No {specialEvents ? 'Parties ' : 'Events '}
                for {formatDate(eventDate)}</MDTypography>}
              columns={columns}
              keyField={'guid'}
              data={eventsFiltered}
              onSort={handleSort}
              highlightOnHover
              onRowClicked={(row) => {
                handleRowClick(row);
              }}
              selectableRows={!embedded}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggledClearRows}
              conditionalRowStyles={conditionalRowStyles}
              pagination
              paginationPerPage={pageSize}
              paginationComponent={ExtendedBootyPagination}
              paginationTotalRows={totalRecords}
              onChangePage={handlePageChange}
              progressPending={loading}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationRowsPerPageOptions={[10, 50, 100, 500]}
              defaultSortFieldId={getCookie('EVENTS_SORT') || 1}
              defaultSortAsc={getCookie('EVENTS_SORT_DIR') === 'desc' ? false : true}
              paginationComponentOptions={PaginationOptions}
            />}
          </Grid>
        </Grid>

      </MDBox>

      {massEdit && <ManageMassInventoryEventModal
        massEdit={true}
        show={massEdit}
        events={selectedRows}
        handleSave={() => {
          setMassEdit(false);
          getReport();
        }}
        handleClose={() => {
          setMassEdit(false);
        }}
      />
      }
    </>
  )
}